export const formatToPercentage = (num: number, digitsAfterPoint = 0) => {
  return (num * 100).toFixed(digitsAfterPoint) + '%';
};
